import React from "react";
import {
  BookOpen,
  Gauge,
  Handshake,
  Package,
  BaggageClaim,
  Wallet,
  Landmark,
  ShoppingCart,
  Store,
  Settings,
  IdCard,
  BarChart3,
  FileText,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "utils";
import { usePermission } from "hooks";
import { logo } from "assets/images";

const navItems = [
  {
    id: 1,
    name: "Tổng quan",
    icon: <Gauge className="w-4 h-4 text-white hover:text-[#eeeeee]" />,
    pathname: ROUTES.PRIVATE_ROOT.DASHBOARD,
    isCheckAdmin: false,
  },
  {
    id: 2,
    name: "Kế toán",
    icon: <BaggageClaim className="w-4 h-4 text-white hover:text-[#eeeeee]" />,
    pathname: "",
    isCheckAdmin: false,
    children: [
      /* ================= SỐ DƯ ĐẦU KỲ ================= */
      {
        id: "acc-1",
        title: "Số dư đầu kỳ",
        icon: <Package className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-1-1",
            name: "Tồn kho đầu kỳ",
            path: ROUTES.ACCOUNTING.OPENING_INVENTORY,
          },
          {
            id: "acc-1-2",
            name: "Công nợ đầu kỳ",
            path: ROUTES.ACCOUNTING.OPENING_DEBT,
          },
        ],
      },

      /* ================= TIỀN MẶT ================= */
      {
        id: "acc-2",
        title: "Tiền mặt",
        icon: <Wallet className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-2-1",
            name: "Phiếu thu",
            path: ROUTES.ACCOUNTING.CASH_RECEIPT,
          },
          {
            id: "acc-2-2",
            name: "Phiếu chi",
            path: ROUTES.ACCOUNTING.CASH_PAYMENT,
          },
        ],
      },

      /* ================= TIỀN GỬI ================= */
      {
        id: "acc-3",
        title: "Tiền gửi",
        icon: <Landmark className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-3-1",
            name: "Thu tiền chuyển khoản",
            path: ROUTES.ACCOUNTING.BANK_RECEIPT,
          },
          {
            id: "acc-3-2",
            name: "Chi tiền chuyển khoản",
            path: ROUTES.ACCOUNTING.BANK_PAYMENT,
          },
        ],
      },

      /* ================= MUA HÀNG ================= */
      {
        id: "acc-4",
        title: "Mua hàng",
        icon: <ShoppingCart className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-4-1",
            name: "Chứng từ mua hàng",
            path: ROUTES.ACCOUNTING.PURCHASE_DOCUMENT,
          },
          {
            id: "acc-4-2",
            name: "Chứng từ nhập hàng bán trả lại",
            path: ROUTES.ACCOUNTING.PURCHASE_RETURN,
          },
        ],
      },

      /* ================= BÁN HÀNG ================= */
      {
        id: "acc-5",
        title: "Bán hàng",
        icon: <Store className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-5-1",
            name: "Chứng từ bán hàng",
            path: ROUTES.ACCOUNTING.SALES_DOCUMENT,
          },
          {
            id: "acc-5-2",
            name: "Chứng từ khác",
            path: ROUTES.ACCOUNTING.OTHER_DOCUMENT,
          },
        ],
      },

      /* ================= SẢN XUẤT ================= */
      // {
      //   id: "acc-6",
      //   title: "Sản xuất, phân tách",
      //   icon: <Factory className="w-4 h-4 text-blue-600" />,
      //   children: [
      //     {
      //       id: "acc-6-1",
      //       name: "Lệnh sản xuất",
      //       path: ROUTES.ACCOUNTING.PRODUCTION_ORDER,
      //     },
      //     {
      //       id: "acc-6-2",
      //       name: "Phân tách nguyên vật liệu",
      //       path: ROUTES.ACCOUNTING.MATERIAL_SPLIT,
      //     },
      //   ],
      // },

      /* ================= TIỀN LƯƠNG ================= */
      // {
      //   id: "acc-7",
      //   title: "Tiền lương",
      //   icon: <Coins className="w-4 h-4 text-blue-600" />,
      //   children: [
      //     {
      //       id: "acc-7-1",
      //       name: "Danh sách bảng lương",
      //       path: ROUTES.ACCOUNTING.PAYROLL_LIST,
      //     },
      //     {
      //       id: "acc-7-2",
      //       name: "Bảng thanh toán tiền lương",
      //       path: ROUTES.ACCOUNTING.PAYROLL_PAYMENT,
      //     },
      //   ],
      // },

      /* ================= KẾ TOÁN KHO ================= */
      // {
      //   id: "acc-8",
      //   title: "Kế toán kho",
      //   icon: <Package className="w-4 h-4 text-blue-600" />,
      //   children: [
      //     {
      //       id: "acc-8-1",
      //       name: "Kiểm kê",
      //       path: ROUTES.ACCOUNTING.INVENTORY_CHECK,
      //     },
      //     {
      //       id: "acc-8-2",
      //       name: "Nhập kho",
      //       path: ROUTES.ACCOUNTING.WMS_IN,
      //     },
      //     {
      //       id: "acc-8-3",
      //       name: "Xuất kho",
      //       path: ROUTES.ACCOUNTING.WMS_OUT,
      //     },
      //     {
      //       id: "acc-8-4",
      //       name: "Chuyển kho",
      //       path: ROUTES.ACCOUNTING.WMS_TRANSFER,
      //     },
      //   ],
      // },

      /* ================= TIỆN ÍCH ================= */
      // {
      //   id: "acc-9",
      //   title: "Tiện ích",
      //   icon: <Settings className="w-4 h-4 text-blue-600" />,
      //   children: [
      //     {
      //       id: "acc-9-1",
      //       name: "Tính lại giá vốn",
      //       path: ROUTES.ACCOUNTING.RECALCULATE_COST,
      //     },
      //     {
      //       id: "acc-9-2",
      //       name: "Cảnh báo nhắc nhở",
      //       path: ROUTES.ACCOUNTING.NOTIFICATION,
      //     },
      //     {
      //       id: "acc-9-3",
      //       name: "Khóa sổ kế toán",
      //       path: ROUTES.ACCOUNTING.CLOSE_BOOK,
      //     },
      //     {
      //       id: "acc-9-4",
      //       name: "Thiết lập kế toán",
      //       path: ROUTES.ACCOUNTING.ACCOUNTING_SETTING,
      //     },
      //   ],
      // },
    ],
  },
  {
    id: 3,
    name: "Danh mục",
    icon: <Package className="w-4 h-4 text-white hover:text-[#eeeeee]" />,
    pathname: "",
    isCheckAdmin: false,
    children: [
      {
        id: "obj-1",
        title: "Đối tượng",
        icon: <Handshake className=" w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "obj-1-1",
            name: "KH / NCC",
            path: ROUTES.PRIVATE_ROOT.OBJECTIVE_CUSTOMER_OR_SUPLIES,
          },
          {
            id: "obj-1-2",
            name: "Nhân viên",
            path: ROUTES.PRIVATE_ROOT.OBJECTIVE_EMPLOYEE,
          },
          {
            id: "obj-1-3",
            name: "Phòng ban",
            path: ROUTES.PRIVATE_ROOT.OBJECTIVE_DEPARTMENT,
          },
        ],
      },
      {
        id: "prod-1",
        title: "Vật tư, hàng hóa",
        icon: <Package className=" w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "prod-1-1",
            name: "Đơn vị tính",
            path: ROUTES.PRIVATE_ROOT.OBJECTIVE_UNIT,
          },
          {
            id: "prod-1-2",
            name: "Nhóm hàng hóa",
            path: ROUTES.PRIVATE_ROOT.WMS_ITEM_GROUPS,
          },
          {
            id: "prod-1-3",
            name: "Hàng hóa",
            path: ROUTES.PRIVATE_ROOT.WMS_ITEMS,
          },
          {
            id: "prod-1-4",
            name: "Kho hàng",
            path: ROUTES.PRIVATE_ROOT.WMS_CODES,
          },
        ],
      },
      {
        id: "acc-code-1",
        title: "Quản lý tài khoản",
        icon: <IdCard className=" w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "acc-3-0",
            name: "Tài khoản ngân hàng",
            path: ROUTES.ACCOUNTING.BANK_ACCOUNTS,
          },
          {
            id: "prod-1-1",
            name: "Mã tài khoản",
            path: ROUTES.PRIVATE_ROOT.ACCOUNT_CODES,
          },
        ],
      },
    ],
  },
  {
    id: 30,
    name: "Báo cáo",
    icon: <BarChart3 className="w-4 h-4 text-white hover:text-[#eeeeee]" />,
    pathname: "",
    isCheckAdmin: false,
    children: [
      {
        id: "rp-tt",
        title: "Sổ sách báo cáo theo thông tư",
        icon: <BookOpen className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "rp-tt-1",
            name: "Sổ chi tiết doanh thu bán hàng hóa, dịch vụ (Mẫu S1a-HKD)",
            path: ROUTES.REPORTS.RP_S1A_HKD,
          },
          {
            id: "rp-tt-2",
            name: "Sổ chi tiết vật liệu, dụng cụ, sản phẩm, hàng hóa (Mẫu S2-HKD)",
            path: ROUTES.REPORTS.RP_S2_HKD,
          },
          {
            id: "rp-tt-3",
            name: "Sổ chi phí sản xuất, kinh doanh (Mẫu S3a-HKD)",
            path: ROUTES.REPORTS.RP_S3A_HKD,
          },
          {
            id: "rp-tt-4",
            name: "Sổ nghĩa vụ thuế Nhà nước (Mẫu S4-HKD)",
            path: ROUTES.REPORTS.RP_S4_HKD,
          },
          {
            id: "rp-tt-5",
            name: "Sổ theo dõi tình hình thanh toán tiền lương (Mẫu S5-HKD)",
            path: ROUTES.REPORTS.RP_S5_HKD,
          },
          {
            id: "rp-tt-6",
            name: "Sổ quỹ tiền mặt (Mẫu S6-HKD)",
            path: ROUTES.REPORTS.RP_S6_HKD,
          },
          {
            id: "rp-tt-7",
            name: "Sổ tiền gửi ngân hàng (Mẫu S7-HKD)",
            path: ROUTES.REPORTS.RP_S7_HKD,
          },
        ],
      },
      {
        id: "rp-admin",
        title: "Sổ sách, báo cáo quản trị",
        icon: <Settings className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "rp-ad-1",
            name: "Báo cáo nhập xuất tồn vật tư",
            path: ROUTES.REPORTS.RP_IN_OUT,
          },
          {
            id: "rp-ad-2",
            name: "Báo cáo công nợ",
            path: ROUTES.REPORTS.RP_ACCOUNT_RECEIVABLE,
          },
          {
            id: "rp-ad-3",
            name: "Sổ chi tiết công nợ",
            path: ROUTES.REPORTS.RP_ACCOUNT_RECEIVABLE_DETAIL,
          },
          {
            id: "rp-ad-4",
            name: "Báo cáo chi tiết giảm GTGT",
            path: ROUTES.REPORTS.RP_DOWN_GTGT_TAX,
          },
          {
            id: "rp-ad-5",
            name: "Tình hình hoạt động và tài chính",
            path: ROUTES.REPORTS.RP_HKD_STATE,
          },
          {
            id: "rp-ad-6",
            name: "Sổ chi tiết mua hàng",
            path: ROUTES.REPORTS.RP_PURCHURE_PRODUCT_DETAIL,
          },
          {
            id: "rp-ad-7",
            name: "Sổ chi tiết bán hàng",
            path: "/bao-cao/so-chi-tiet-ban-hang",
          },
          {
            id: "rp-ad-8",
            name: "Thống kê khách hàng doanh số",
            path: "/bao-cao/thong-ke-khach-hang-doanh-so",
          },
          {
            id: "rp-ad-9",
            name: "Báo cáo khoản mục thu chi",
            path: "/bao-cao/bao-cao-khoan-muc-thu-chi",
          },
        ],
      },

      {
        id: "rp-invoice",
        title: "Báo cáo hóa đơn",
        icon: <FileText className="w-4 h-4 text-blue-600" />,
        children: [
          {
            id: "rp-inv-1",
            name: "Bảng kê hóa đơn bán hàng (Mẫu GTGT)",
            path: "/bao-cao/hoa-don-ban-hang-gtgt",
          },
          {
            id: "rp-inv-2",
            name: "Thống kê chi tiết hóa đơn (Mẫu GTGT)",
            path: "/bao-cao/thong-ke-hoa-don-gtgt",
          },
          {
            id: "rp-inv-3",
            name: "Bảng kê hóa đơn bán hàng (Mẫu CNKD)",
            path: "/bao-cao/hoa-don-ban-hang-cnkd",
          },
          {
            id: "rp-inv-4",
            name: "Báo cáo doanh thu theo sản phẩm",
            path: "/bao-cao/doanh-thu-theo-san-pham",
          },
        ],
      },
    ],
  },
  // {
  //   id: 7,
  //   name: "Cài đặt",
  //   pathname: ROUTES.PRIVATE_ROOT.USERS,
  //   icon: <SettingsIcon className="w-4 h-4 text-white hover:text-[#eeeeee]" />,
  //   isCheckAdmin: true,
  //   children: [
  //     {
  //       id: 1,
  //       title: "Cấu hình hóa đơn",
  //       icon: <CogIcon className="text-blue-600" />,
  //       children: [
  //         { id: "1-1", name: "Cấu hình chứng thư số", path: "/invoice/cert" },
  //         { id: "1-2", name: "Đăng ký sử dụng HĐĐT", path: "/invoice/dang-ky" },
  //         { id: "1-3", name: "Quản lý mẫu hóa đơn", path: "/invoice/mau" },
  //         { id: "1-4", name: "Cấu hình dải hóa đơn", path: "/invoice/dai" },
  //       ],
  //     },

  //     {
  //       id: 2,
  //       title: "Phát hành hóa đơn",
  //       icon: <BanknoteIcon className="text-blue-600" />,
  //       children: [
  //         { id: "2-1", name: "Quản lý hóa đơn", path: "/invoice/publish" },
  //         {
  //           id: "2-2",
  //           name: "Dữ liệu hóa đơn từ máy tính tiền",
  //           path: "/invoice/mtt",
  //         },
  //       ],
  //     },

  //     {
  //       id: 3,
  //       title: "Xử lý hóa đơn",
  //       icon: <Dock className="text-blue-600" />,
  //       children: [
  //         {
  //           id: "3-1",
  //           name: "Tra cứu hóa đơn từ Invoice",
  //           path: "/invoice/tra-cuu",
  //         },
  //         {
  //           id: "3-2",
  //           name: "Danh sách hóa đơn chưa gửi thông báo sai sót",
  //           path: "/invoice/chua-gui",
  //         },
  //         { id: "3-3", name: "Thông báo sai sót", path: "/invoice/sai-sot" },
  //         { id: "3-4", name: "Hóa đơn thay thế", path: "/invoice/thay-the" },
  //         { id: "3-5", name: "Xem thêm...", path: "/invoice/more" },
  //       ],
  //     },

  //     {
  //       id: 4,
  //       title: "Lịch sử cơ quan thuế",
  //       icon: <Clock10Icon className="text-blue-600" />,
  //       children: [
  //         {
  //           id: "4-1",
  //           name: "Kết quả dữ liệu hóa đơn từ MTT gửi CQT",
  //           path: "/invoice/mtt-cqt",
  //         },
  //         { id: "4-2", name: "Lịch sử giao dịch", path: "/invoice/lich-su" },
  //       ],
  //     },

  //     {
  //       id: 5,
  //       title: "Hóa đơn đầu vào",
  //       icon: <PartyPopper className="text-blue-600" />,
  //       children: [
  //         {
  //           id: "5-1",
  //           name: "Cấu hình hóa đơn đầu vào",
  //           path: "/invoice/hd-vao/config",
  //         },
  //         {
  //           id: "5-2",
  //           name: "Tra cứu hóa đơn đầu vào",
  //           path: "/invoice/hd-vao/tra-cuu",
  //         },
  //         {
  //           id: "5-3",
  //           name: "Quản lý hóa đơn đầu vào",
  //           path: "/invoice/hd-vao/quan-ly",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const normalizePath = (path) => {
  if (!path) return "";
  return path.replace(/\/+$/, "");
};

const isPathActive = (pathname, targetPath) => {
  if (!targetPath) return false;
  const current = normalizePath(pathname);
  const target = normalizePath(targetPath);
  if (!target) return false;
  return current === target || current.startsWith(`${target}/`);
};

const findActiveMatch = (pathname) => {
  let bestMatch = { menuId: null, path: null, length: -1 };
  const updateMatch = (menuId, path) => {
    if (!isPathActive(pathname, path)) return;
    const length = normalizePath(path).length;
    if (length > bestMatch.length) {
      bestMatch = { menuId, path, length };
    }
  };
  navItems.forEach((item) => {
    updateMatch(item.id, item.pathname);
    item.children?.forEach((section) => {
      section.children?.forEach((child) => {
        updateMatch(item.id, child.path);
      });
    });
  });
  return bestMatch;
};

export default function Sidebar() {
  const { isAdmin } = usePermission();
  const router = useNavigate();
  const { pathname } = useLocation();
  const [openMenuId, setOpenMenuId] = React.useState(null);
  const [collapsedActiveMenuId, setCollapsedActiveMenuId] =
    React.useState(null);
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const sidebarRef = React.useRef(null);
  const activeMatch = React.useMemo(
    () => findActiveMatch(pathname),
    [pathname],
  );
  const activeMenuId = activeMatch.menuId;
  const previousActiveMenuId = React.useRef(activeMenuId);
  const renderSidebarIcon = (icon) => {
    if (!icon) return null;
    return React.cloneElement(icon, {
      className: "h-5 w-5 text-white",
    });
  };
  const handleNavigate = (name, isCheckAdmin) => {
    if (isCheckAdmin && !isAdmin) {
      return;
    }
    if (!name) return;
    router(name);
  };
  React.useEffect(() => {
    if (previousActiveMenuId.current !== activeMenuId) {
      setCollapsedActiveMenuId(null);
      previousActiveMenuId.current = activeMenuId;
    }
  }, [activeMenuId]);
  React.useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setOpenMenuId(null);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);
  return (
    <aside
      ref={sidebarRef}
      className={`relative no-scrollbar z-30 transition-all duration-300 bg-[#1c55b1] text-slate-800 border-r border-slate-200 shadow-xl flex flex-col pt-6 ${isCollapsed ? "w-20" : "w-64"}`}
      style={{ maxHeight: "100vh", minHeight: "100vh" }}
    >
      <div className={`transition-all duration-300 ${isCollapsed ? "flex justify-center px-2" : "px-5"}`}>
        <button
          type="button"
          className={`flex items-center gap-3 rounded-lg py-1 hover:bg-slate-200/60 transition ${isCollapsed ? "w-12 h-12 justify-center p-1" : "w-full px-2"}`}
          onClick={() => handleNavigate(ROUTES.PRIVATE_ROOT.DASHBOARD, false)}
        >
          <img
            src={logo}
            alt="Senbook"
            className={`drop-shadow shrink-0 object-contain ${isCollapsed ? "w-10 h-10" : "h-10 w-auto"}`}
          />
          {!isCollapsed && (
            <span className="text-sm font-semibold tracking-wide text-white whitespace-nowrap">
              Senbook
            </span>
          )}
        </button>
      </div>
      <nav className={`relative mt-6 flex-1 ${isCollapsed ? "" : "overflow-y-auto no-scrollbar"} overflow-visible px-3 space-y-2 pb-6`}>
        {navItems.map((item) => {
          const isPassed = (item.isCheckAdmin && isAdmin) || !item.isCheckAdmin;
          const hasChildren = item.children?.length > 0;
          const isOpen = openMenuId === item.id;
          const isActiveGroup = hasChildren && item.id === activeMenuId;
          const isActiveGroupCollapsed =
            isActiveGroup && collapsedActiveMenuId === item.id;
          const isActiveTopLevel =
            !hasChildren && isPathActive(pathname, item.pathname);
          const isExpanded =
            hasChildren &&
            (isOpen || (isActiveGroup && !isActiveGroupCollapsed));
          const shouldHighlight = isOpen || isActiveGroup || isActiveTopLevel;
          const handleItemClick = () => {
            if (hasChildren) {
              if (isActiveGroup) {
                if (isExpanded) {
                  setCollapsedActiveMenuId(item.id);
                  if (isOpen) {
                    setOpenMenuId(null);
                  }
                } else {
                  setCollapsedActiveMenuId(null);
                }
                return;
              }
              setOpenMenuId(isOpen ? null : item.id);
              return;
            }
            handleNavigate(item.pathname, item.isCheckAdmin);
          };
          return isPassed ? (
            <div className={`relative ${isCollapsed ? "group" : ""}`} key={item.id}>
              <button
                type="button"
                title={item.name}
                data-ripple-light="true"
                data-tooltip-target={`tooltip-right-${item.id}`}
                onClick={handleItemClick}
                className={`w-full flex items-center rounded-xl py-3 text-left bg-white/0 text-slate-800 transition focus-visible:outline-none focus-visible:ring-2 shadow-sm shadow-black/5 ${isCollapsed ? "justify-center px-0" : "justify-between px-4"}`}
              >
                <div className={`flex items-center gap-3 text-white hover:text-slate-500 ${isCollapsed ? "justify-center" : ""}`}>
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center text-white hover:text-slate-500">
                    {renderSidebarIcon(item.icon)}
                  </span>
                  {!isCollapsed && (
                    <span className="text-[15px] font-medium leading-none text-white hover:text-slate-500 whitespace-nowrap">
                      {item.name}
                    </span>
                  )}
                </div>
                {!isCollapsed && hasChildren ? (
                  isExpanded ? (
                    <ChevronDown className="h-4 w-4 shrink-0 text-slate-500 transition-transform" />
                  ) : (
                    <ChevronRight className="h-4 w-4 shrink-0 text-slate-500 transition-transform" />
                  )
                ) : (
                  !isCollapsed && <span className="h-4 w-4 shrink-0" />
                )}
              </button>
              {hasChildren && (
                <div
                  className={`
                    no-scrollbar flex-col gap-4 bg-white/95 text-slate-800 shadow-xl rounded-xl p-4 border border-slate-100
                    max-h-[calc(100vh-120px)] overflow-y-auto
                    ${
                      isCollapsed
                        ? // Flyout mode: absolute positioned to the right, shown on hover via group-hover
                          "hidden group-hover:flex absolute left-full top-0 ml-1 min-w-[260px] z-[9999] shadow-2xl"
                        : // Inline expand mode
                          isExpanded
                          ? "flex mt-2 w-full max-w-full min-w-0 z-10"
                          : "hidden"
                    }
                  `}
                >
                  {item.children.map((section) => (
                    <div key={section.id} className="space-y-2">
                      <div
                        className={`flex items-center gap-2 font-semibold text-[15px] leading-none ${
                          section.children?.some((child) =>
                            isPathActive(pathname, child.path),
                          )
                            ? "text-blue-700"
                            : "text-slate-800"
                        }`}
                      >
                        {section.icon}
                        {section.title}
                      </div>
                      <div className="pl-7 space-y-2">
                        {section.children.map((child) => (
                          <button
                            key={child.id}
                            onClick={() =>
                              handleNavigate(child.path, item.isCheckAdmin)
                            }
                            className={`block text-left w-full py-1 text-sm transition ${
                              isPathActive(pathname, child.path)
                                ? "text-blue-800 font-semibold"
                                : "text-blue-700 hover:text-blue-600"
                            }`}
                          >
                            {child.name}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <></>
          );
        })}
      </nav>
      <div className="px-4 mt-auto pt-4 border-t border-[#2668d2] flex justify-center pb-4">
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={`p-2 bg-[#2d73e6]/50 hover:bg-[#2d73e6] text-white rounded transition-colors flex items-center ${isCollapsed ? "justify-center w-full" : "justify-center w-full"}`}
        >
          {isCollapsed ? <ChevronRight className="w-5 h-5"/> : <ChevronLeft className="w-5 h-5"/>}
          {!isCollapsed && <span className="ml-2 text-sm font-medium">Thu gọn</span>}
        </button>
      </div>
    </aside>
  );
}
